import { SET_URL_UTILS } from "./UrlParametersAction";

/**
 *
 * @param {*} state
 * @param {*} action
 * Reducer for login popup visibility
 *
 */
export default function UrlParametersReducer(
    state = {
        urlUtils: new Map(),
    },
    action
) {
    switch (action.type) {
        case SET_URL_UTILS:
            let url = window.location.search
            let splittedSearch = url.split("?")
            let urlParameters = new Map()

            if (splittedSearch.length > 0) {
                for (let i = 0; i < splittedSearch.length; i++) {
                    if (splittedSearch[i] !== "") {
                        let replacedSearch = splittedSearch[i].replaceAll("&", "")
                        let splittedReplacedSearch = replacedSearch.split("=")

                        urlParameters.set(splittedReplacedSearch[0], splittedReplacedSearch[1])
                    }
                }
            }

            return {
                ...state,
                urlUtils: urlParameters
            };
        default:
            return state;
    }
}
